import React from "react";

import ButtonDropdown from "../../../../components/ButtonDropdown";

// Cada tela passa só as opções que fazem sentido para ela (contas a pagar,
// por exemplo, não precisa de "Receita").
export const NewEntryButton = ({ onReceivable, onPayable, onTransfer }) => {
    const actions = [
        onReceivable && { text: 'Receita', svg: 'plus-circle', action: onReceivable },
        onPayable && { text: 'Despesa', svg: 'plus-circle', action: onPayable },
        onTransfer && { text: 'Transferência', svg: 'refresh', action: onTransfer },
    ].filter(Boolean);

    return <ButtonDropdown type={`primary`} size={`small`} text={`Nova`} actions={actions} />;
};

export default NewEntryButton;
